export type ResizeMode = 'cover' | 'contain';
export type OutputFormat = 'origin' | 'png' | 'jpeg' | 'webp' | 'avif';

interface BuildUrlParams {
  width: number;
  height?: number;
  quality?: number;
  resize?: ResizeMode;
  format?: OutputFormat;
}

const DEFAULT_QUALITY = 75;

const STORAGE_HOST_SUFFIX = process.env.NEXT_PUBLIC_STORAGE_IMAGE_HOST_SUFFIX ?? '';

const isStorageHost = (url: URL): boolean => !!STORAGE_HOST_SUFFIX && url.hostname.endsWith(STORAGE_HOST_SUFFIX);

const ensureRenderEndpoint = (url: URL): void => {
  if (url.pathname.startsWith('/storage/v1/object/public/')) {
    url.pathname = url.pathname.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/');
  }
};

/**
 * Строит URL изображения из storage с трансформацией (width, height, quality, resize, format).
 */
export const buildStorageTransformUrl = (absoluteSrc: string, params: BuildUrlParams): string => {
  const {width, height, quality = DEFAULT_QUALITY, resize = 'cover', format} = params;
  try {
    const url = new URL(absoluteSrc);
    if (!isStorageHost(url)) return absoluteSrc;
    ensureRenderEndpoint(url);
    url.searchParams.set('width', String(width));
    if (typeof height === 'number' && height > 0) {
      url.searchParams.set('height', String(height));
    }
    url.searchParams.set('quality', String(quality));
    url.searchParams.set('resize', resize);
    if (format) {
      url.searchParams.set('format', format);
    }
    return url.toString();
  } catch {
    return absoluteSrc;
  }
};

/**
 * Генерирует blur-плейсхолдер.
 */
export const buildStorageBlurUrl = (absoluteSrc: string): string => {
  return buildStorageTransformUrl(absoluteSrc, {width: 16, quality: 30, resize: 'contain'});
};
